import { API } from '../config/AppConfig';
import {
  CHART_ACCURACY_BREAKDOWN,
  RVU_OPP,
  DASHBOARD_RVU_OPP_BREAKDOWN,
  DEPARTMENT_PROVIDER,
  GET_DASHBOARD_CQ_SCORE,
  GET_DEPARTMENT_NAME,
  PHYSICIAN_LIST,
  DASHBOARD_RVU_OPPORTURINTY,
  UPDATE_ACCURACY_REVIEW_STATUS,
} from '../constants/Endpoints';
import { applyDateType } from '../utils/common.utils';

class DepartmentDashboardRepository {
  async getDepartmentCqScore(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(GET_DASHBOARD_CQ_SCORE, {
      queryParams: finalParams,
    });
    return response;
  }

  async getRevenueOpportunity(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(RVU_OPP, {
      queryParams: finalParams,
    });
    return response;
  }

  async getrevenueopporturityScore(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(DASHBOARD_RVU_OPPORTURINTY, {
      queryParams: finalParams,
    });
    return response;
  }

  async getOutstandingRevenue(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(DASHBOARD_RVU_OPP_BREAKDOWN, {
      queryParams: finalParams,
    });
    return response;
  }

  async getProviders(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(DEPARTMENT_PROVIDER, {
      queryParams: finalParams,
    });
    return response;
  }

  async getPhysicians(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(PHYSICIAN_LIST, {
      queryParams: finalParams,
    });
    return response;
  }

  async getAuditChartAccuracy(queryParams) {
    const finalParams = applyDateType(queryParams);
    const response = await API.get(CHART_ACCURACY_BREAKDOWN, {
      queryParams: finalParams,
    });
    return response;
  }

  async getDepartmentName(departmentId) {
    const response = await API.get(GET_DEPARTMENT_NAME, {
      pathParams: { departmentId },
    });
    return response;
  }

  async updateAccuracyReviewStatus(rowData) {
    try {
        // const { chart_id, location, review } = rowData;
        const response = await API.put(UPDATE_ACCURACY_REVIEW_STATUS, {
            body: rowData
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to update review status');
    }
  }
}

const departmentDashboardRepository = new DepartmentDashboardRepository();
export default departmentDashboardRepository;
